<app-loading></app-loading>
<div>
    <app-header-page [description]="headerDescription" [schoolClinic]="schoolClinic"></app-header-page>
</div>

<div>
    <ng-content select="[content-container]"></ng-content>
</div>